import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime.js';
import { Button, Flex } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks.js';
import { accountIdentifierEmailSelector, isLoadingSelector, updateEmailError, updateEmailErrorMessage, verifyAccountExistsThunk, } from '../accountIdentifierSlice.js';
import { validateEmail } from '../../../helpers/validateEmail.js';
import { EmailAddressInput } from './EmailAddressInput.js';
import { useTrack } from '../../../tracking/common/hooks/useTrack.js';
import { AutoCompleteFormWrapper } from '../../../components/common/AutoCompleteFormWrapper/AutoCompleteFormWrapper.js';
export const EmailInputWithButton = () => {
    const { t } = useTranslation();
    const { value } = useAppSelector(accountIdentifierEmailSelector);
    const isLoading = useAppSelector(isLoadingSelector);
    const dispatch = useAppDispatch();
    const { trackBtnClick, trackFieldError } = useTrack('twoStep');
    const verifyButtonClick = () => {
        trackBtnClick({ uniqueName: 'continueWithEmail' });
        const isValidEmail = validateEmail(value);
        if (!isValidEmail) {
            dispatch(updateEmailError(true));
            dispatch(updateEmailErrorMessage(t('loginregistration.email.validation.error')));
            trackFieldError({ formFieldErrors: 'emailAddressNotValid' });
        }
        if (isValidEmail) {
            dispatch(verifyAccountExistsThunk());
        }
    };
    return (_jsx(Flex, { flxDirection: 'column', children: _jsxs(AutoCompleteFormWrapper, { children: [_jsx(EmailAddressInput, {}), _jsx(Button, { "data-testid": "rlac-primary-continue-btn", "data-dd-action-name": "rla_forms_twoStep_continueWithEmailClick", variant: "primary", a11yLabel: t('loginregistration.twoStepLoginRegistration.button.continue.a11yLabel'), type: "submit", onClick: verifyButtonClick, isLoading: isLoading, isFullWidth: true, marginTop: 'spaceL', size: ['medium'], children: t('loginregistration.twoStepLoginRegistration.button.continue') })] }) }));
};
//# sourceMappingURL=EmailInputWithButton.js.map